import { defineStore } from 'pinia'
import { useUserStore } from './user'
export const useLoaderStore = defineStore('loader', {
  state: () => ({
    loading: false,
    type: "card",
    alerts: []
  }),
  actions: {
    show() {
      this.loading = true
    },
    hide(){
        this.loading = false
    },
    setLoaderType(type){
        this.type = type
    },
    setAlert({
      message,
      type = 'error',
      color,
      timeout = 5000,
      ...rest
    })  {
      const userStore = useUserStore()
      if(!userStore.userId) return 
      const id = Date.now()

      this.alerts.push({
        id,
        message,
        type,
        color: color || this.getColor(type),
        ...rest
      })

      if (timeout) {
        setTimeout(() => {
          this.removeAlert(id)
        }, timeout)
      }
    },
    removeAlert(id){
      this.alerts = this.alerts.filter(alert => alert.id !== id)
    },
    getColor(type) {
      switch (type) {
        case 'success':
          return 'green'
        case 'warning':
          return 'orange'
        default:
          return 'red'
      }
    }
  }
})